

















































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { Student as IStudent } from "@/api-v2/course/models";
import TableActions from "@/components/form/TableActions.vue";
import { courseApi } from "@/getinfo-api";
import { consentModule } from "@/plugins/modules-detect";

@Component({
  components: { TableActions, CustomTableCol, CustomTableItem, CustomTable }
})
export default class StudentListItem extends Vue {
  @Prop() student!: IStudent;
  @Prop() isLoading!: boolean;
  @Prop() isShowAction!: boolean;
  @Prop() checked!: boolean;
  @Prop() isBlocked!: boolean;
  @Prop({ default: true }) selectable!: boolean;
  isCheck: boolean = false;
  isRemoving: boolean = false;
  uniqId: string = this.isConsentModuleEnabled
    ? "id" +
      Math.random()
        .toString(16)
        .slice(2)
    : "";

  get fullName() {
    return this.student
      ? `${this.student.lastName} ${this.student.firstName} ${
          this.student.middleName ? this.student.middleName : ""
        }`
      : "";
  }

  get isConsentModuleEnabled() {
    return consentModule();
  }

  get consentUserInfo() {
    return {
      isShow: this.isConsentModuleEnabled && this.student?.user?.consent,
      value: this.student?.user?.consent
        ? this.$converter.date(this.student?.user?.consentAt!)
        : this.$tc(this.$translate.DidNotAgree)
    };
  }

  changeCheckBox() {
    this.$emit("check", this.student);
  }

  @Watch("checked", {
    immediate: true
  })
  checkChecked() {
    this.isCheck = this.checked;

  }

  studentEdit() {
    let routeData = this.$router.resolve({
      name: "studentEdit",
      params: { id: this.student.id }
    });
    window.open(routeData.href, "_blank");
  }
  studentRemove() {
    this.isRemoving = true;
    courseApi.Student.deleteStudent(this.student.id).finally(() => {
      this.isRemoving = false;
      this.$emit("studentRemove", this.student.id);
    });
  }
}
